module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7264c0b67b765f818b43510d45822a3f.png";